globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.SenderEditName = (function(superClass) {

  utils.extend(SenderEditName, superClass);

  function SenderEditName() {
    return SenderEditName.__super__.constructor.apply(this, arguments);
  }

  $.extend(SenderEditName.prototype, {
    callbackSuccess: function(data) {
      var controller = this;

      controller.$form = this.$html.find('form').first();
      if (!data.response) {
        appCustomerSpace.LimitlessPlugins.Validation.errors({
          $form: controller.$form,
          errors: JSON.parse(data.errors)
        });
        appCustomerSpace.Loader().stop();
      } else {
        SenderEditName.__super__.callbackSuccess.apply(this, arguments);
      }
    },
    updateView: function(response) {
      if (response.sender_row_html) {
        $(".tr-sender-" + response.sender_uniq_key).replaceWith($(response.sender_row_html));
      }
    }
  });

  return SenderEditName;

})(appCustomerSpace.Modal);
